"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiModuleRootPath = void 0;
exports.UiModuleRootPath = {
    welcome: 'welcome',
    financialProfile: 'financial-profile',
    qyjClientFinancialProfile: 'client-financial-profile',
    qyjProspectFinancialProfile: 'prospect-financial-profile',
    dashboard: 'dashboard',
    tools: 'tools',
    debt: 'debt',
    emergencySavings: 'rainy-day',
    medicareMatch: 'medicare-match',
    healthCareCostEstimator: 'health-care-cost-estimator',
    retirement: 'retirement',
    riskAttitude: 'risk-attitude',
    spendingStrategy: 'spending-strategy',
    addCash: 'add-cash',
    topTips: 'top-tips',
    editRetirement: 'edit-retirement',
    revisitRetirement: 'revisit-retirement',
    portfolio: 'portfolio',
    prospect: 'prospect',
    pendingOffboard: 'pending-offboard',
    scheduleAppointment: 'schedule-appointment',
    congratulations: 'congratulations',
    return: 'return',
    riskQuiz: 'risk-quiz',
    retirementGoal: 'retirement-goal',
    customGoal: 'custom-goal',
    tradeoffExperience: 'goal-optimizer',
    openAnAccount: 'open-an-account',
    enroll: 'enroll',
    confirmRetirement: 'confirm-retirement',
    resetOffer: 'reset-offer',
    portfolioCustomization: 'portfolio-customization',
    requiredMinimumDistribution: 'required-minimum-distribution',
    taxLossOption: 'tax-loss-option',
    offerUpgradeDowngrade: 'offer-switch',
    portfolioBuilder: 'portfolio-builder',
    fastpath: 'fastpath',
    prospectFastpath: 'prospect-fastpath',
    enrollmentPath: 'enrollment-path',
    prospectEnrollmentPath: 'prospect-enrollment-path',
    addPartner: 'add-partner'
};
